package com.devi3east.bashbuddy.auth.ui

import com.devi3east.bashbuddy.account.organization.domain.models.Organization
import com.devi3east.bashbuddy.account.profile.domain.models.Profile
import com.devi3east.bashbuddy.leaderboard.domain.models.OrganizationLeaderboardItem

data class AuthUiState(
    var isLoading: Boolean = false,
    val errorMessage: String? = null,
    val token: String? = null,
    val profile: Profile? = null,
    val organization: Organization? = null,
    val organizations: List<Organization> = emptyList(),
    val leaderboard: List<OrganizationLeaderboardItem> = emptyList(),
    val isStripeSetupStarted: Boolean = false,
    val isActive: Boolean = true,
    val isHydrating: Boolean = true
)